import React from "react";
import { useSearchParams } from "react-router-dom";
import { BookOpen, LayoutGrid, Trophy } from "lucide-react";
import { Education, DailyQuiz } from "@/rahsia";
import { useAuth } from "@/context/AuthContext";

const SUBS = [
  { key: "pdf", label: "Ebook PDF", icon: BookOpen },
  { key: "infographic", label: "Infographic", icon: LayoutGrid },
  { key: "quiz", label: "Daily Quiz", icon: Trophy },
];

function RahsiaFrame({ children, testId }) {
  return (
    <div className="rahsia rounded-2xl border border-slate-200 overflow-hidden max-w-2xl" data-testid={testId}>
      <div className="content" style={{ padding: "20px 16px 28px" }}>{children}</div>
    </div>
  );
}

export default function EbookHub({ ebooks }) {
  const [params, setParams] = useSearchParams();
  const { user } = useAuth();
  const sub = params.get("sub") || "pdf";
  const setSub = (v) => {
    const next = new URLSearchParams(params);
    next.set("sub", v);
    setParams(next, { replace: true });
  };

  return (
    <div>
      <div className="grid grid-cols-3 sm:flex gap-2 mb-6" data-testid="ebook-subtabs">
        {SUBS.map(({ key, label, icon: Icon }) => (
          <button
            key={key}
            data-testid={`ebook-subtab-${key}`}
            onClick={() => setSub(key)}
            className={`shrink-0 inline-flex items-center justify-center gap-1.5 sm:gap-2 px-2 sm:px-4 py-2 rounded-full border text-xs sm:text-sm font-display font-semibold whitespace-nowrap ${
              sub === key ? "bg-[#00b4ff] border-[#00b4ff] text-white" : "bg-white border-slate-200 text-slate-600 hover:border-[#00b4ff] hover:text-[#00b4ff]"
            }`}
            style={{ transition: "background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease" }}
          >
            <Icon size={14} /> {label}
          </button>
        ))}
      </div>
      {sub === "pdf" && ebooks}
      {sub === "infographic" && <RahsiaFrame testId="infographic-section"><Education /></RahsiaFrame>}
      {sub === "quiz" && <RahsiaFrame testId="daily-quiz-section"><DailyQuiz user={user} /></RahsiaFrame>}
    </div>
  );
}
